import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ConfirmAddPersonnel from "../../../ui/ConfirmAddPersonnel";
import SocieteAndUserService from "../../../services/societeAndUser";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { PermCameraMic } from "@material-ui/icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import ConfirmAddAdminAccount from "../../../ui/ConfirmAddAdminAccount";

const codeCategorie = [
  { id: "1", value: "P" },
  { id: "2", value: "M" },

  { id: "3", value: "C" },
];

const type = [
  { id: "CIVIL", value: "Civile" },
  { id: "SOCIETE", value: "Société" },
];

const typeTVA = [
  { id: "NORMAL", value: "Normale" },
  { id: "EXPORTATRICE", value: "Exportatrice" },
];
const typeSoceite = [{ id: "PARTNER", value: "Partenaire" }];
const AddAdminAccount = () => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [personalName, setPersonalName] = useState("");
  const [isCancel, setIsCancel] = useState(false);
  const [personalSociete, setPersonalSociete] = useState("");
  const [showLocalisationAndTruck, setShowLocalisationAndTruck] =
    useState(false);

  const [selectedOption, setSelectedOption] = useState(null);

  const [allRoles, setAllRoles] = useState([]);
  const [allAvailableSociete, setAllAvailableSociete] = useState([]);

  const [personalPrenom, setPersonalPrenom] = useState("");

  const [personalCIN, setPersonalCIN] = useState("");

  const [personalLocalisation, setPersonalLocalisation] = useState("");
  const [personalCamion, setPersonalCamion] = useState("");
  const [personalPassword, setPersonalPassword] = useState("");
  const [personalRePassword, setPersonalRePassword] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [personalPhoneNumber, setPersonalPhoneNumber] = useState("");
  const displayLocalisation = useRef(null);
  const displayCamion = useRef(null);

  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [onConfirmAddPersonnel, setOnConfirmAddPersonnel] = useState(false);
  const [confirmPersonnelModel, setConfirmPersonnelModel] = useState();

  useEffect(() => {
    SocieteAndUserService.getAllRoles()
      .then((response) => {
        if (Object.keys(response.data)[0] == "Role") {
          let roleData = [];
          response.data.Role.forEach((element) => {
            if (element.name == "ADMIN") {
              roleData.push(element.id.toString());
            }
          });
          setAllRoles(roleData);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
    let availableClientSociete = [];
    SocieteAndUserService.getAllSocieteForAdminAccount()
      .then((response) => {
        //heree5
        if (Object.keys(response.data)[0] == "Societe") {
          if (response.data.Societe.length != 0) {
            response.data.Societe.forEach((element) => {
              availableClientSociete.push({
                label: element.title
                  ? `${element.matricule} - ${element.title}`
                  : element.matricule,
                value: element.id,
              });
            });
            setAllAvailableSociete(availableClientSociete);
          } else {
            toast.info(
              "Aucune entreprise, vous devez ajouter une entreprise en premier"
            );

            setTimeout(function () {
              window.location.replace("/adminSociete");
            }, 2000);
            // setTimeout(navigation(), 50000);
          }

          //   setPersonalSociete(response.data.Societe.id);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  }, []);

  const navigation = () => {
    window.location.href = "/adminSociete";
  };

  useEffect(() => {
    if (
      onConfirmAddPersonnel == false &&
      confirmPersonnelModel != null &&
      isCancel == false
    ) {
      window.location.href = "/addAdminAccount";
    }
  }, [onConfirmAddPersonnel]);

  // useEffect(() => {
  //   let indexTransportor = 0;

  //   console.log("cdjhfjdh");
  //   console.log(selectedOption);
  //   allRoles.forEach((element) => {
  //     if (element.label == "transporteur") {
  //       indexTransportor = element.value;
  //     }
  //   });
  //   console.log(indexTransportor);

  //   if (selectedOption.includes(indexTransportor)) {
  //     displayLocalisation.current.style.display = "block";
  //     displayCamion.current.style.display = "block";
  //     setShowLocalisationAndTruck(true);
  //   } else {
  //     setShowLocalisationAndTruck(false);
  //     displayLocalisation.current.style.display = "none";
  //     displayCamion.current.style.display = "none";
  //   }

  //   //  if(selectedOption.)
  // }, [selectedOption]);

  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangepersonalName = (event) => {
    setPersonalName(event.target.value);
  };

  const onChangePersonalPrenom = (event) => {
    setPersonalPrenom(event.target.value);
  };

  const onChangePersonalCin = (event) => {
    setPersonalCIN(event.target.value);
  };

  const onChangePersonalEmail = (event) => {
    setPersonalEmail(event.target.value);
  };
  const onChangePersonalPhoneNumber = (event) => {
    setPersonalPhoneNumber(event.target.value);
  };

  const onChangePersonalLocalisation = (event) => {
    setPersonalLocalisation(event.target.value);
  };

  const onChangePersonalCamion = (event) => {
    setPersonalCamion(event.target.value);
  };

  const onChangePersonalPassword = (event) => {
    setPersonalPassword(event.target.value);
  };

  const onChangePersonalRePassword = (event) => {
    setPersonalRePassword(event.target.value);
  };

  const onUploadImageHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      const file = e.target.files[0];

      setFile(file);
      setFileName(e.target.files[0].name);
    }
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onConfirmedAddPersonnelHandler = () => {
    if (personalPassword == "") {
      setErrorAlertText("Erreur :le champ mot de passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalRePassword == "") {
      setErrorAlertText("Erreur :le champ confirmer mot passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalRePassword != personalPassword) {
      setErrorAlertText("Erreur : mot de passe non confirmé ! ");
      setOpenErrorAlert(true);
    } else if (personalRePassword == "") {
      setErrorAlertText("Erreur :le champ confirmer mot passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalName == "") {
      setErrorAlertText("Erreur :le champ nom  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalPrenom == "") {
      setErrorAlertText("Erreur :le champ prénom  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalCIN == "") {
      setErrorAlertText("Erreur :le champ CIN  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalEmail == "") {
      setErrorAlertText("Erreur :le champ email est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalPhoneNumber == "") {
      setErrorAlertText("Erreur :le champ télephone est vide ! ");
      setOpenErrorAlert(true);
    } else if (selectedOption == null) {
      setErrorAlertText("Erreur :Aucune société ! ");
      setOpenErrorAlert(true);
    } else if (showLocalisationAndTruck == true) {
      if (personalLocalisation == "") {
        setErrorAlertText("Erreur :le champ localisation est vide ! ");
        setOpenErrorAlert(true);
      } else if (personalCamion == "") {
        setErrorAlertText("Erreur :le champ camion est vide ! ");
        setOpenErrorAlert(true);
      } else if (file == null) {
        setErrorAlertText("Erreur :le champ image est vide ! ");
        setOpenErrorAlert(true);
      } else {
        let confirmModel = {
          nom: personalName,
          prenom: personalPrenom,
          cin: personalCIN,
          email: personalEmail,
          numPhone: personalPhoneNumber,
          idSociete: personalSociete,
          idUserCreation: 0,
          mdp: personalPassword,
          remdp: personalPassword,
          file: file,
          localisation: personalLocalisation,
          camion: personalCamion,
        };

        let roleArray = [];

        selectedOption.forEach((element) => {
          roleArray.push(element.toString());
        });

        confirmModel.roleIds = roleArray;

        setConfirmPersonnelModel(confirmModel);
        setOnConfirmAddPersonnel(true);
      }
    } else if (file == null) {
      setErrorAlertText("Erreur :le champ image est vide ! ");
      setOpenErrorAlert(true);
    } else {
      let confirmModel = {
        nom: personalName,
        prenom: personalPrenom,
        cin: personalCIN,
        email: personalEmail,
        numPhone: personalPhoneNumber,
        idSociete: selectedOption?.value,
        idUserCreation: 0,
        mdp: personalPassword,
        remdp: personalPassword,
        file: file,
        roleIds: allRoles,
      };
      console.log(confirmModel);

      // let roleArray = [];

      // selectedOption.forEach((element) => {
      //   roleArray.push(element.toString());
      // });

      // confirmModel.roleIds = roleArray;
      console.log(confirmModel);

      setConfirmPersonnelModel(confirmModel);
      setOnConfirmAddPersonnel(true);
    }
  };

  const onChangeSelectedSocieteHandler = (e) => {
    console.log(e);
    setSelectedOption(e);

    //   setSelectedOption();
    //   setRoleId(selectedOptionn.value);
    //   setRoleSelectPlaceHolder(selectedOptionn.label);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <ToastContainer />
                  <h5 class="card-title"> Donner accès au client (une société peut avoir plusieurs admins)</h5>
                </div>
              </div>

              <div class="card  mt-3" style={{ height: "83%" }}>
                <div class="card-body">
                  <div class="row" style={{ marginTop: 10 }}>
                    <div className="form-group" class="col-sm-4">
                      <label htmlFor="inputName">Nom</label>
                      <input
                        placeholder="Ajouter Nom "
                        onChange={onChangepersonalName}
                        type="text"
                        id="inputName"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group" class="col-sm-4">
                      <label htmlFor="inputName">Prénom</label>
                      <input
                        placeholder="Ajouter prénom "
                        onChange={onChangePersonalPrenom}
                        type="text"
                        id="inputName"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group" class="col-sm-4">
                      <label htmlFor="inputName">CIN</label>
                      <input
                        placeholder="Ajouter CIN "
                        onChange={onChangePersonalCin}
                        type="text"
                        id="inputName"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group" class="col-sm-6">
                      <label htmlFor="inputName">Email</label>
                      <input
                        placeholder="Ajouter email "
                        onChange={onChangePersonalEmail}
                        type="email"
                        id="inputName"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group" class="col-sm-6">
                      <label htmlFor="inputName">Télephone</label>
                      <input
                        placeholder="Ajouter Télephone"
                        onChange={onChangePersonalPhoneNumber}
                        type="text"
                        id="inputName"
                        className="form-control"
                      />
                    </div>

                    <div
                      className="form-group"
                      class=" col-8 col-sm-4 "
                      style={{ marginTop: 0 }}
                    >
                      <div>
                        <label>Choisir une société </label>
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          defaultValue={selectedOption}
                          onChange={onChangeSelectedSocieteHandler}
                          options={allAvailableSociete}
                          placeholder={
                            allAvailableSociete.length > 0 ? "Choisir " : "Vide"
                          }
                        />

                        {/* <Select
                          //   closeMenuOnSelect={false}
                          //   components={animatedComponents}

                          className="dropdown"
                          //   defaultValue={selectedOption}
                          options={allAvailableSociete}
                          value={selectedOption}
                          onChange={onChangeSelectedSocieteHandler}
                          placeholder={
                            allAvailableSociete.length > 0 ? "Choisir " : "Vide"
                          }
                          isClearable
                        /> */}
                      </div>
                    </div>

                    {/* <div
                      className="form-group"
                      class="col-sm-4"
                      ref={displayLocalisation}
                    >
                      <label htmlFor="inputName">Localisation</label>
                      <input
                        placeholder="Ajouter localisation "
                        onChange={onChangePersonalLocalisation}
                        type="text"
                        id="inputName"
                        className="form-control"
                      />
                    </div> */}

                    {/* <div
                      className="form-group"
                      class="col-sm-4"
                      ref={displayCamion}
                    >
                      <label htmlFor="inputName">Camion</label>
                      <input
                        placeholder="Ajouter camion "
                        onChange={onChangePersonalCamion}
                        type="text"
                        id="inputName"
                        className="form-control"
                      />
                    </div> */}

                    <div className="form-group" class="col-sm-4">
                      <label htmlFor="inputName">Mot de passe</label>
                      <input
                        placeholder="Ajouter mot de passe "
                        onChange={onChangePersonalPassword}
                        type="password"
                        id="inputName"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group" class="col-sm-4">
                      <label htmlFor="inputName">
                        Confirmez le mot de passe
                      </label>
                      <input
                        placeholder="Ajouter mot de passe "
                        onChange={onChangePersonalRePassword}
                        type="password"
                        id="inputName"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group" class="col-sm-6">
                      <div
                        class="input-group mb-3 px-2 py-2   sm-white border"
                        style={{ marginTop: 100 }}
                      >
                        <input
                          id="upload"
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          className="form-control border-0"
                          onChange={onUploadImageHandler}
                        />

                        <label
                          id="upload-label"
                          for="upload"
                          class="font-weight-light text-muted"
                        >
                          {fileName}
                        </label>
                        <div class="input-group-append">
                          <label
                            for="upload"
                            class="btn btn-light m-0 rounded-pill px-4"
                          >
                            {" "}
                            <i class="fa fa-cloud-upload mr-2 text-muted"></i>
                            <small class="text-uppercase font-weight-bold text-muted">
                              Choisir une image
                            </small>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group" class="col-sm-6">
                      {/* <p class="font-italic text-black text-center">
                        The image uploaded will be rendered inside the box
                        below.
                      </p> */}
                      {/* style={{ height: 200 , paddingLeft : -10 }} */}
                      <div
                        class="image-area mt-4"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        {fileDataURL ? (
                          <img
                            id="imageResult"
                            src={fileDataURL}
                            alt
                            style={{ height: 197, width: 620 }}
                            className="img-fluid rounded shadow-sm mx-auto d-block"
                          />
                        ) : (
                          <img
                            style={{ marginTop: 180 }}
                            id="imageResult"
                            src="#"
                            alt
                            className="img-fluid rounded shadow-sm mx-auto d-block"
                          />
                        )}
                      </div>
                    </div>

                    <div class="col-sm-5"> </div>

                    <div
                      className="form-group"
                      class="col-sm-2"
                      style={{ marginTop: 32 }}
                    >
                      <a
                        href="#"
                        class="btn btn-success "
                        onClick={onConfirmedAddPersonnelHandler}
                      >
                        Ajouter
                      </a>{" "}
                    </div>
                    <div class="col-sm-5"> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>

      {onConfirmAddPersonnel && (
        <ConfirmAddAdminAccount
          setOnConfirmAddPersonnel={setOnConfirmAddPersonnel}
          confirmPersonnelModel={confirmPersonnelModel}
          setIsCancel={setIsCancel}
        />
      )}
    </div>
  );
};
export default AddAdminAccount;
